/* L4 Header „Beratung“: Karte (Desktop, Disclosure direkt hinter dem Auslöser) und Blatt von unten (mobil, <dialog>). Ohne Bibliothek. */
(function () {
  var current = null;
  var cardOf = function (btn) { return document.getElementById(btn.getAttribute('aria-controls')); };
  var close = function (returnFocus) {
    if (!current) return;
    var btn = current;
    current = null;
    var card = cardOf(btn);
    if (card) card.hidden = true;
    btn.setAttribute('aria-expanded', 'false');
    if (returnFocus) btn.focus();
  };
  var open = function (btn) {
    if (current && current !== btn) close(false);
    var card = cardOf(btn);
    if (!card) return;
    current = btn;
    card.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
  };
  var inside = function (el) {
    if (!current || !el) return false;
    var card = cardOf(current);
    return current.contains(el) || (card && card.contains(el));
  };
  Array.prototype.slice.call(document.querySelectorAll('[data-gw-bt-toggle]')).forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (current === btn) close(false); else open(btn);
    });
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && current) { e.preventDefault(); close(true); }
  });
  document.addEventListener('click', function (e) { if (current && !inside(e.target)) close(false); });
  document.addEventListener('focusin', function (e) { if (current && !inside(e.target)) close(false); });
  /* Pille scrollt weg bzw. Sticky-Symbol wird unsichtbar: Karte schließen */
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (!current || ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      if (!current) return;
      var r = current.getBoundingClientRect();
      if (r.bottom < 0 || getComputedStyle(current).visibility === 'hidden') close(false);
    });
  }, { passive: true });

  var sheet = document.getElementById('gw-beratung-blatt');
  if (sheet && typeof sheet.showModal === 'function') {
    var opener = null;
    Array.prototype.slice.call(document.querySelectorAll('[data-gw-bt-sheet-open]')).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        opener = btn;
        sheet.showModal();
        btn.setAttribute('aria-expanded', 'true');
      });
    });
    var x = sheet.querySelector('[data-gw-bt-sheet-close]');
    if (x) x.addEventListener('click', function () { sheet.close(); });
    sheet.addEventListener('click', function (e) {
      if (e.target !== sheet) return;
      var r = sheet.getBoundingClientRect();
      if (e.clientY < r.top || e.clientY > r.bottom || e.clientX < r.left || e.clientX > r.right) sheet.close();
    });
    sheet.addEventListener('close', function () {
      if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); }
    });
  }
})();
